import api from "./axios";

export const getQuestions = (params) => api.get("faq/questions/", { params });
export const createQuestion = (data) => api.post("faq/questions/", data);
export const updateQuestion = (id, data) => api.patch(`faq/questions/${id}/`, data);
export const createAnswer = (data) => api.post("faq/answers/", data);
export const updateAnswer = (id, data) => api.patch(`faq/answers/${id}/`, data);
export const deleteQuestion = (id) => api.delete(`faq/questions/${id}/`);
export const deleteAnswer = (id) => api.delete(`faq/answers/${id}/`);
